import React from 'react';
import styled from '@emotion/styled';
import { Row, Col } from 'react-bootstrap';

type Props = {
  headerText?: string;
  children?: React.ReactNode;
  colWidth?: number;
  style?: Record<string, string>;
  className?: string;
};
const Heading = styled.h2``;

function Section({
  className,
  style = {},
  headerText,
  children,
  colWidth = 12,
}: Props) {
  return (
    <Row className={className}>
      <Col md={colWidth} style={style}>
        {!headerText || <Heading>{headerText}</Heading>}
        {children}
      </Col>
    </Row>
  );
}

export default Section;
